import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import backk from './images/backk.png'; // Ensure the path is correct

const Deletes = () => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const userEmail = sessionStorage.getItem('userEmail'); // Get userEmail from session storage
  const navigate = useNavigate(); // For navigation

  const handleBackClick = () => {
    navigate(-1); // Navigate back
  };

  const handleConfirmClick = () => {
    setShowDeleteConfirm(true); // Show confirmation popup
  };

  const handleDeleteRecord = async () => {
    try {
      const response = await fetch('/deleteRecord', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ gmail: userEmail }), // Send userEmail as Gmail
      });

      if (response.ok) {
        setShowDeleteConfirm(false); // Close the confirmation modal
        alert('Record Deleted Successfully!');
      } else {
        const data = await response.json();
        alert(data.message || 'Deletion failed, please try again.');
      }
    } catch (error) {
      console.error('Error deleting record:', error);
      alert('An error occurred while deleting the record.');
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false); // Close the confirmation popup
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        height: '100vh',
        background: 'linear-gradient(90deg, #fff7ad, #ffa9f9)', // Background gradient
      }}
    >
      <div style={{ marginTop: '20px' }}>
        <h2 style={{ color: '#E11584' }}>Delete Screen</h2>
        <p style={{ color: '#E11584' }}>Signed in as: {userEmail}</p>
        <h3>Are you sure you want to delete your records?</h3>
        <button
          onClick={handleConfirmClick}
          style={{
            backgroundColor: '#E11584',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginTop: '10px',
          }}
        >
          Confirm
        </button>
      </div>

      {/* Confirmation popup */}
      {showDeleteConfirm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '10px',
              textAlign: 'center',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
            }}
          >
            <h3>Delete Record?</h3>
            <button
              onClick={handleDeleteRecord}
              style={{
                backgroundColor: '#E11584',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '10px',
                marginRight: '10px',
              }}
            >
              Yes
            </button>
            <button
              onClick={handleCancelDelete}
              style={{
                backgroundColor: '#E11584',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '10px',
              }}
            >
              No
            </button>
          </div>
        </div>
      )}

      {/* Back button */}
      <div style={{ marginTop: 'auto' }}>
        <button onClick={handleBackClick} style={{ marginTop: '20px' }}>
          <img src={backk} width="40" height="40" alt="Back" />
        </button>
      </div>
    </div>
  );
};

export default Deletes;
